import React from "react";
import axios from "axios";

export const resetPasswordApi = async (token, password) => {

  try {
    let url = `https://visapro-api.tcore.online/api/v1/auth/reset-password`;
    const response = await axios.post(url, {
      token,
      password,
    });
    const reset = {
      data: response,
    };

    return reset;
  } catch (error) {
    const reset = {
      error: error,
    };
    return reset;
  }
};
